const attachmentBlock = document.querySelector('[data-contact-attachment]');

if (attachmentBlock) {
  const input = attachmentBlock.querySelector('input[type="file"]');
  const token = attachmentBlock.querySelector('input[name="attachment_token"]');
  const name = attachmentBlock.querySelector('[data-contact-attachment-name]');
  const remove = attachmentBlock.querySelector('[data-contact-attachment-remove]');
  const error = attachmentBlock.querySelector('[role="alert"]');
  const submit = document.getElementById('contact-send-message');
  let uploading = false;
  let failed = false;
  let request = null;
  let generation = 0;

  const setBusy = (busy) => {
    uploading = busy;
    attachmentBlock.setAttribute('aria-busy', String(busy));
    if (submit) submit.disabled = busy || failed;
  };

  const discard = (value) => {
    if (!value) return;
    $.ajax({
      url: `${site_url}page/upload_contact_attachment`,
      type: 'POST',
      dataType: 'json',
      data: { remove_token: value },
    });
  };

  const clear = () => {
    generation += 1;
    if (request) request.abort();
    request = null;
    discard(token.value);
    token.value = '';
    input.value = '';
    name.textContent = 'No file selected';
    error.textContent = '';
    input.removeAttribute('aria-invalid');
    remove.hidden = true;
    failed = false;
    setBusy(false);
  };

  window.contactAttachmentReady = () => !uploading && !failed;
  remove.addEventListener('click', clear);

  input.addEventListener('change', () => {
    const file = input.files?.[0];
    if (!file) return;
    clear();
    const currentGeneration = generation;
    name.textContent = file.name;
    remove.hidden = false;

    const fail = (message) => {
      failed = true;
      error.textContent = message;
      input.setAttribute('aria-invalid', 'true');
      setBusy(false);
    };

    if (!/\.(pdf|doc|docx|txt)$/i.test(file.name)) {
      fail('Allowed formats are PDF, DOC, DOCX and TXT.');
      return;
    }
    if (!file.size || file.size > 5242880) {
      fail('Please choose a non-empty file up to 5MB.');
      return;
    }

    setBusy(true);
    name.textContent = `Uploading ${file.name}…`;
    const data = new FormData();
    data.append('attachment', file);
    request = $.ajax({
      url: `${site_url}page/upload_contact_attachment`,
      type: 'POST',
      data,
      dataType: 'json',
      processData: false,
      contentType: false,
      success: (result) => {
        if (currentGeneration !== generation) {
          discard(result.attachment_token);
          return;
        }
        if (result.error || !/^[a-f0-9]{48}$/.test(result.attachment_token || '')) {
          fail(typeof result.error === 'string' ? result.error : 'Attachment upload failed. Please try again or remove the attachment.');
          return;
        }
        token.value = result.attachment_token;
        name.textContent = file.name;
        setBusy(false);
      },
      error: (_, status) => {
        if (currentGeneration !== generation || status === 'abort') return;
        fail('Attachment upload failed. Please try again or remove the attachment.');
      },
    });
  });

  attachmentBlock.closest('form').addEventListener('submit', (event) => {
    event.preventDefault();
    if (window.contactAttachmentReady()) window.reCaptchaContactForm();
  });
}
